import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = {
  key: 0,
  width: "40",
  height: "40"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("circle", {
  class: "circle-stroke",
  "stroke-width": "4",
  fill: "transparent",
  r: "13",
  cx: "20",
  cy: "20"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ['ml-2 leading-4', _ctx.canUpgrade && 'mt-2']
    }, [
      (_ctx.requestLeft !== undefined)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: [_ctx.percentage < 30 && 'text-btn-danger', "text-14 md:text-16"]
          }, _toDisplayString(_ctx.requestLeft) + " " + _toDisplayString(_ctx.$t('header.left')), 3))
        : _createCommentVNode("", true),
      (_ctx.canUpgrade)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            class: "uppercase md:font-semibold text-link text-8 md:text-10",
            to: { name: 'membership' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('actions.upgrade-now')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.requestLeft !== undefined)
      ? (_openBlock(), _createBlock("svg", _hoisted_2, [
          _hoisted_3,
          _createVNode("circle", {
            class: ["circle-progress", _ctx.percentage < 30 ? 'circle-progress-red' : 'circle-progress-blue'],
            "stroke-width": "4",
            fill: "transparent",
            r: "13",
            cx: "20",
            cy: "20"
          }, null, 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}